import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, FileText, ShieldCheck, Zap } from 'lucide-react';
export function NewAuthority() {
  const stats = [{
    icon: BookOpen,
    value: '+100',
    label: 'Recetas naturales'
  }, {
    icon: FileText,
    value: '+250',
    label: 'Páginas de contenido'
  }, {
    icon: ShieldCheck,
    value: '50+',
    label: 'Problemas cubiertos'
  }, {
    icon: Zap,
    value: '100%',
    label: 'Acceso inmediato'
  }];
  return <Section className="bg-forest-deep text-white py-16" data-id="element-70">
      <div className="max-w-6xl mx-auto" data-id="element-71">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center" data-id="element-72">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-73">
              <stat.icon className="w-8 h-8 text-honey mb-4 opacity-80" data-id="element-74" />
              <div className="text-3xl md:text-4xl font-serif font-bold text-cream-warm mb-2" data-id="element-75">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-cream-warm/70 uppercase tracking-wider font-medium" data-id="element-76">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}